import { TLanguages } from 'core/config/locale'
import { locales } from '@/i18nConfig'

const loadLocale = async (locale: TLanguages) => {
  switch (locale) {
    case 'en_US':
      return (await import('./en_US')).default
    case 'zh_CN':
      return (await import('./zh_CN')).default
    case 'zh_HK':
      return (await import('./zh_HK')).default
    case 'th_TH':
      return (await import('./th_TH')).default
    case 'fil_PH':
      return (await import('./fil_PH')).default
    case 'es_ES':
      return (await import('./es_ES')).default
    case 'ja_JP':
      return (await import('./ja_JP')).default
    case 'pt_PT':
      return (await import('./pt_PT')).default
    case 'vi_VN':
      return (await import('./vi_VN')).default
    case 'fr_FR':
      return (await import('./fr_FR')).default
    /* case 'tr_TR':
      return (await import('./tr_TR')).default */
    case 'de_DE':
      return (await import('./de_DE')).default
    case 'ru_RU':
      return (await import('./ru_RU')).default
    case 'it_IT':
      return (await import('./it_IT')).default
    case 'longest':
      // 如果是 longest 则返回最长的语言包
      return (await import('./longest')).default
    default:
      // 默认使用英语
      return (await import('./en_US')).default
  }
}

export default loadLocale
